import { isShellRuntime } from './shellDetection';
import { usePhoneNavigation } from './usePhoneNavigation';

/**
 * IU-1 (`docs/concept-iphone-ux.md#iu-1-one-scroller-the-document`, S-1/S-2/S-3): does the document
 * itself scroll for this view, with no `overflow-y: auto` box of its own inside the page?
 *
 * ⛔ **Shell mode, in phone mode — not phone mode alone.** A browser at a phone width, mobile Safari
 * included, keeps today's nested scroller (`<main>` scrolls) until a later slice extends the
 * document-scroll model to it too; this slice's own test (`iphone-shell.spec.ts`, *a browser keeps
 * its scroller*) pins exactly that boundary. `isPhoneNavigation()` alone is the wrong predicate here
 * — it is `true` for a narrow browser — so this composes it with `isShellRuntime()`.
 *
 * Every reader of "is this page the one scroller" (`Layout.tsx`'s `<main>`, `ActivityPage.tsx`'s two
 * inner boxes, `scrollScreenToTop`) calls this and nothing narrower, so the three cannot drift.
 */
export function useSinglePageScroller(): boolean {
  // The hook runs on every render, before the shell check, so the hook order never changes.
  const phoneNavigation = usePhoneNavigation();
  return isShellRuntime() && phoneNavigation;
}
